import Project_1 from "./images/Project 1.jpg"
import Project_2 from "./images/Project 2.jpg";
import Project_3 from "./images/Project 3.jpg";

const mywork_data = [
  {
    w_no: 1,
    w_name: "WebStudio",
    w_img: Project_1,
    w_link: "https://nikkipotomakha.github.io/goit-markup-hw-06/",
  },
  {
    w_no: 2,
    w_name: "Focus.Frame",
    w_img: Project_2,
    w_link: "https://olehkotynskyi.github.io/project-GROUP_WORK/",
  },
  {
    w_no: 3,
    w_name: "Food Boutique",
    w_img: Project_3,
    w_link: "https://olehkotynskyi.github.io/project-GROUP_WORK_JS/",
  },
];


export default mywork_data;
